(() => {
  angular
    .module('app.campaign')
    .controller('CampaignManagerController', CampaignManager);

  CampaignManager.$inject = [
    '$q',
    '$scope',
    '$filter',
    '$rootScope',
    '$window',
    '$location',
    '$interval',
    'Targetgroup',
    'ModalService',
    'CampaignManagerService',
  ];

  function CampaignManager(
    $q,
    $scope,
    $filter,
    $rootScope,
    $window,
    $location,
    $interval,
    Targetgroup,
    ModalService,
    CampaignManagerService,
  ) {
    const baseRouteTester = /\/(((create)(\/(\d*))?(\/(sameTrackpoints|newTrackpoints))?)|((edit)\/(\d*)))$/;
    const currentUser = $('#current-user');
    const accountId = currentUser.data('company-id');

    const vm = this;
    vm.saving = false;
    vm.doPrompt = true;
    vm.isDmsOn = currentUser.data('feature-dms') === 1;
    vm.isLimitUser = [1051, 1021].includes(accountId);

    vm.title = () => {
      vm.campaign = CampaignManagerService.getCampaignData();
      return $location.path().indexOf('/edit') !== -1 ?
        vm.campaign && vm.campaign.name : 'Create a campaign';
    }

    vm.isIntegrated = () => {
      vm.campaign = CampaignManagerService.getCampaignData();
      return vm.campaign && vm.campaign.type === 'integrated';
    }

    vm.type = () => vm.isIntegrated() ? 'Integrated report' : '';

    vm.campaignIdParam = {
      'id': parseInt($location.path().split('/')[2]),
    };

    vm.isSaveButtonDisabled = () => (
      !CampaignManagerService.canTouchCampaign() &&
      !CampaignManagerService.canSaveSnapshots() &&
      !CampaignManagerService.canSendToDms()
    );

    function isShowWarning() {
      const action = $location.path().split('/')[1];

      if (action === 'create') {
        return false;
      }

      const isDirty = CampaignManagerService.isCampaignFieldChanged('panel_country') ||
                      CampaignManagerService.isCampaignFieldChanged('trackpoints');

      return vm.campaign && vm.campaign.sourceFor.length !== 0 && isDirty;
    }

    const doRedirect = () => {
      let goto = document.referrer;
      if (goto && goto.includes('/quality/')) {
        goto = `${goto.split('/quality/')[0]}/quality`;
      }

      $window.location.href = goto;
    }

    function saveCampaign() {
      if (!vm.saving) {
        vm.saving = true;

        const action = $location.path().split('/')[1];
        let savePromise;
        if (action == 'edit') {
          savePromise = CampaignManagerService.updateCampaign();
          window.mixpanel && window.mixpanel.track("Campaign updated", { pid: vm.campaignIdParam.id });
        } else if (action == 'create') {
          savePromise = CampaignManagerService.createCampaign();
          window.mixpanel && window.mixpanel.track("Campaign created");
        }

        savePromise.then(
          // on success
          data => {
            if (data.error) {
              vm.saving = false;
              console.error(data.error);

              if (data.error.ex) {
                const ex = JSON.parse(data.error.ex);
                Notification.showSimpleError(ex.error?.rules?.message || ex.error?.message);
              } else {
                Notification.showSimpleError(data.error.message?.split('\n')[0]);
              }

              return false;
            }

            const promises = [];

            if (CampaignManagerService.canSaveSnapshots()) {
              promises.push(CampaignManagerService.saveNewSnapshots(data.id));
              promises.push(CampaignManagerService.deleteSnapshots(data.id));
            }

            if (CampaignManagerService.canSendToDms()) {
              promises.push(CampaignManagerService.saveDms(data.id));
            }

            if (promises.length !== 0) {
              $q.all(promises).then(() => {
                vm.saving = false;
                vm.doPrompt = false;

                doRedirect();
              });
            } else {
              vm.saving = false;
              vm.doPrompt = false;

              doRedirect();
            }
          },
          // on failure
          response => {
            vm.saving = false;
            console.error(response);

            const error = response.error || response.data;

            if (error.ex) {
              const ex = JSON.parse(error.ex);
              Notification.showSimpleError(ex.error?.rules?.message || ex.error?.message);
            } else {
              Notification.showSimpleError(error.message?.split('\n')[0]);
            }
          }
        );
      }
    }

    vm.saveCampaign = () => {
      if (isShowWarning() && !window.localStorage.getItem('ir_hide_warning')) {
        ModalService.showModal({
          templateUrl: '/assets/js/app/campaign/modals/editWithSources.html',
          controller: 'EditModalController',
          controllerAs: 'editModal',
          inputs: {
            sourceFor: vm.campaign.sourceFor,
          }
        })
        .then(function (modal) {
          modal.element.modal();
          modal.close.then(function (result) {
            if (result) {
              saveCampaign();
            }
          })
        });

        return;
      }

      saveCampaign();
    };

    vm.showAlertTGSize = false;
    vm.checkTGSize = () => {
      if (!vm.campaign) {
        return false;
      }

      const {
        c_start,
        panel_country,
        start,
        target,
        targetSegment
      } = vm.campaign;
      const targetGroup = target ? target.criteria : {};

      const params = {
        countryCode: panel_country,
        startDate: start ? new Date(start) : (c_start ? new Date(c_start) : new Date()),
        targetGroup,
        targetSegment
      };

      const tgSizePromise = Targetgroup.size(params).$promise;
      tgSizePromise.then(({ data }) => {
        vm.showAlertTGSize = data && data.isLow;
      });
    }

    // Navigation and routing logic
    $rootScope.$on('$routeChangeStart', () => vm.isRouteLoading = true);
    $rootScope.$on('$routeChangeSuccess', () => vm.isRouteLoading = false);

    vm.getTabTechedgeIndex = () => {
      if (vm.isIntegrated()) {
        return 5;
      }

      return vm.isDmsOn ? 6 : 5;
    };

    const getTabs = () => {
      const tabs = [
        'details',
      ];

      tabs.push(vm.isIntegrated() ? 'sources' : 'trackingpoints');
      tabs.push('targetgroup');
      tabs.push('reportperiod');
      tabs.push('quality');

      if (vm.isDmsOn && !vm.isIntegrated()) {
        tabs.push('dms');
      }

      tabs.push('techedge');

      return tabs;
    };

    vm.navigation = {
      tabs: getTabs(),
      currentTab: 0,
      hasPrev: function () {
        return this.currentTab != 0;
      },
      hasNext: function () {
        return this.currentTab != this.tabs.length - 1;
      },
      prev: function () {
        this.setTab(this.currentTab - 1);
      },
      next: function () {
        this.setTab(this.currentTab + 1);
      },
      setTab: function (index) {
        this.currentTab = index;
        var pathParts = $location.path().split('/');
        pathParts.pop();
        pathParts.push(getTabs()[index]);
        $location.path(pathParts.join('/'));
      },
      addTab: function (index) {
        this.currentTab = index;
        var pathParts = $location.path().split('/');
        pathParts.push(getTabs()[index]);
        $location.path(pathParts.join('/'));
      },
      activate: function () {
        if (baseRouteTester.test($location.path())) {
          vm.navigation.addTab(0);
        } else {
          const tabPath = $location.path().split('/').pop();
          vm.navigation.currentTab = vm.navigation.tabs.indexOf(tabPath);
        }
      }
    };

    vm.getIntegrationsIndicator = () => CampaignManagerService.getIntegrationsIndicator();

    let updateTGSizeTime = 10;
    let updateTGSizeDelay = null;
    $scope.$watch(() => vm.campaign,
      campaign => {
        if (!updateTGSizeDelay) {
          updateTGSizeDelay = $interval(() => {
            if (updateTGSizeTime-- < 0) {
              $interval.cancel(updateTGSizeDelay);
              updateTGSizeTime = 10;
              updateTGSizeDelay = null;

              vm.checkTGSize();
            }
          }, 100);
        }

        if (campaign && vm.isIntegrated()) {
          vm.navigation.tabs = getTabs();
          vm.navigation.activate();

          CampaignManagerService.setIntegrationsIndicator(campaign.sources);
        }
      }, true);

    vm.getNewTrackpointsAddedAmount = () => CampaignManagerService.getNewTrackpointsAddedAmount();

    vm.getNewTrackpointsAddedNotificationStatus = () => CampaignManagerService.getNewTrackpointsAddedNotificationStatus();

    vm.closeNewTrackpointsAddedNotification = () => {
      CampaignManagerService.showNewTrackpointsAddedNotification(false);
    };

    vm.undoAddedTrackpoints = () => {
      vm.campaign.sources = [...CampaignManagerService.storedData.sources];
      vm.campaign.trackpoints = [...CampaignManagerService.storedData.trackpoints];
      delete CampaignManagerService.storedData;

      CampaignManagerService.showNewTrackpointsAddedNotification(false);
    };

    $scope.$watch(() => vm.campaign,
      campaign => {
        if (campaign && !CampaignManagerService.storedData) {
          CampaignManagerService.storedData = {
            sources: vm.campaign.sources ? [...vm.campaign.sources] : [],
            trackpoints: vm.campaign.trackpoints ? [...vm.campaign.trackpoints] : [],
          };
        }
      }, true);

    // prevents the user from instantly leaving the page if they have unsaved changes
    $window.addEventListener('beforeunload', function (event) {
      if (!vm.isSaveButtonDisabled() && vm.doPrompt) {
        (event || $window.event).returnValue = 'You have unsaved changes. Are you sure you want to leave this page?';
      }
    });

    vm.sidebar = {
      open: false,
      onToggle: () => {
        vm.sidebar.open = !vm.sidebar.open;
        $('body').toggleClass('freeze');
      }
    };

    const getWeeksRange = (date, migrationDate) => {
      const monday = new Date(date);
      monday.setDate(monday.getDate() - (monday.getDay() + 6) % 7); // set to Monday of week
      monday.setDate(monday.getDate() - 7); // set to previous Monday

      const mondayEnd = new Date(migrationDate);
      mondayEnd.setDate(mondayEnd.getDate() - (mondayEnd.getDay() + 6) % 7); // set to Monday of week
      mondayEnd.setDate(mondayEnd.getDate() - 7); // set to previous Monday
      const sunday = new Date(mondayEnd.getFullYear(), mondayEnd.getMonth(), mondayEnd.getDate() + 6); // create new date of sunday

      return {
        monday,
        sunday,
      };
    }

    const interval = $interval(() => {
      const storageDate = localStorage.getItem(`migrationDate${accountId}`);
      if (vm.campaign && storageDate) {
        vm.migrationDate = $filter('dateLong')(storageDate);

        if (vm.isLimitUser) {
          const fixDate = '2024-03-04';

          const today = new Date();
          const migrationDate = new Date(fixDate);
          const weeksRange = getWeeksRange(today < migrationDate ? today : migrationDate, migrationDate);

          vm.campaign.start = vm.campaign.start ? vm.campaign.start : weeksRange.monday;
          vm.campaign.end = vm.campaign.end ? vm.campaign.end : weeksRange.sunday;
        }

        $interval.cancel(interval);
      }
    }, 500);
  }
})();
